import CitySEOHead from "@/components/feature/CitySEOHead";
import PeachtreeCornersHeroSection from "./components/HeroSection";
import PeachtreeCornersStickyNav from "./components/StickyNav";
import PeachtreeCornersProcessingTimeSection from "./components/ProcessingTimeSection";
import PeachtreeCornersServicesSection from "./components/ServicesSection";
import PeachtreeCornersLocalAreaSection from "./components/LocalAreaSection";
import PeachtreeCornersTestimonialsSection from "./components/TestimonialsSection";
import PeachtreeCornersAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PeachtreeCornersComparisonSection from "./components/ComparisonSection";
import PeachtreeCornersMistakesSection from "./components/MistakesSection";
import PeachtreeCornersHowItWorksSection from "./components/HowItWorksSection";
import PeachtreeCornersFAQSection, { faqs } from "./components/FAQSection";
import PeachtreeCornersHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PeachtreeCornersFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const peachtreeCornersServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function PeachtreeCornersPage() {
  return (
    <>
      <CitySEOHead
        city="Peachtree Corners"
        state="Georgia"
        stateAbbr="GA"
        route="/peachtree-corners"
        title="Emergency Passport Peachtree Corners, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Peachtree Corners, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving western Gwinnett County travelers. Get your emergency passport fast!"
        geoPlacename="Peachtree Corners, Georgia"
        geoPosition="33.9698;-84.2216"
        faqs={faqs}
        servicesSchema={peachtreeCornersServices}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Peachtree Corners passport, same day passport Atlanta, fast passport Georgia"
      />
      <div className="font-sans">
        <PeachtreeCornersHeroSection />
        <PeachtreeCornersStickyNav />
        <PeachtreeCornersProcessingTimeSection />
        <PeachtreeCornersLocalAreaSection />
        <PeachtreeCornersServicesSection />
        <PeachtreeCornersTestimonialsSection />
        <PeachtreeCornersAcceptanceFacilitiesSection />
        <PeachtreeCornersComparisonSection />
        <PeachtreeCornersMistakesSection />
        <PeachtreeCornersHowItWorksSection />
        <PeachtreeCornersFAQSection />
        <PeachtreeCornersHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/peachtree-corners" state="GA" />
        <PeachtreeCornersFinalCTA />
      </div>
    </>
  );
}